import { LicenseModuleSummary } from "@/model/data/License/LicenseModuleSummary";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class GetLicensesDataSummaryResData extends ServiceResponseData {
    modules: LicenseModuleSummary[];

    constructor(response: AxiosResponse) {
        super(response);
        this.modules = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    parse(obj: any) {
        if (obj.Modules && obj.Modules.length > 0) {
            obj.Modules.forEach((e) => {
                var m: LicenseModuleSummary = new LicenseModuleSummary();
                m.parse(e);
                this.modules.push(m);
            });
        }
    }
}
